exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scrollable {\n  overflow-y: auto; }\n\nformly-field.col-md-6 {\n  position: relative;\n  width: 100%;\n  padding-right: 30px;\n  padding-left: 11px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/finance-management/finance-transactions/finance-transactions.component.scss
// module id = ../../../../../src/app/finance-management/finance-transactions/finance-transactions.component.scss
// module chunks = main